import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const mineVuex = createNamespacedHelpers("mine");
const assetsVuex = createNamespacedHelpers("assets");
export default {
  name: "cityHead",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "taskCount", "setting"]),
    ...userVuex.mapState(["userData"]),
    ...mineVuex.mapState(["hourEearnings"]),
    ...assetsVuex.mapState(["assetsChainsList", "assetsList"]),
    route() {
      return this.$route.path;
    },
    avatarUrl() {
      return "https://static.tapcoins.app/avatar";
    }
  },
  data() {
    return {
      popMenuShow: false,
      usdInfo: null
    };
  },
  methods: {
    ...assetsVuex.mapActions(["getAssetsList"]),
    onSkip(path, id) {
      if (path == "squad") {
        this.$router.push(`/${path}?id=${id}`);
        return;
      }
      this.$router.push(`/${path}`);
    },
    async getUsdInfo() {
      if (this.assetsList && this.assetsList?.length) {
        this.usdInfo = this.assetsList?.filter(item => {
          return item.name === "usdt" && item.chain == "ton";
        })?.[0];
      } else {
        await this.getAssetsList();
        this.$nextTick(() => {
          this.getUsdInfo();
        });
      }
    }
  },
  async mounted() {
    // this.getEarningsIncrement()
    //this.loadTaskCount();
    this.getUsdInfo();
  }
};